import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AIRTABLE_URL_TECHNICIAN, AIRTABLE_HEADERS } from "../constants";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
  const res = await fetch(`${AIRTABLE_URL_TECHNICIAN}?filterByFormula=AND({support}='${email}', {supportad}='${password}')`, {
  headers: AIRTABLE_HEADERS, // ✅ centralized headers
});

      const data = await res.json();
      const isValid = data.records && data.records.length > 0;

      if (isValid) {
        console.log("✅ Admin authenticated from Airtable");
        localStorage.setItem("adminLoggedIn", "true");
        onLogin && onLogin();
        navigate("/dashboard");
      } else {
        alert("❌ Invalid admin credentials");
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("❌ Login failed due to network or server error");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>office</h2>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder=""
      /><br /><br />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder=""
      /><br /><br />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
}
